import {
  SyncContractDataRequest,
  SyncContractDataResponse,
  SyncUserDataRequest,
  SyncUserDataResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_external_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type SyncContractDataParams = {
  organisationId: string;
  subscriptionId: string;
  action: number;
};

export const syncContractData = async (
  { organisationId, subscriptionId, action }: SyncContractDataParams,
  headers: Record<RequestMetadata, string>
): Promise<SyncContractDataResponse> => {
  const req = new SyncContractDataRequest({
    organizationId: organisationId,
    subscriptionId: subscriptionId,
    action: action,
  });

  return supportServiceConnectClient.syncContractData(req, { headers });
};

type SyncUserDataParams = {
  userId: string;
  organisationId: string;
  name: string;
  email: string;
};

export const syncUserData = async (
  { userId, organisationId, name, email }: SyncUserDataParams,
  headers: Record<RequestMetadata, string>
): Promise<SyncUserDataResponse> => {
  const req = new SyncUserDataRequest({
    userId: userId,
    orgId: organisationId,
    name: name,
    email: email,
  });

  return supportServiceConnectClient.syncUserData(req, { headers });
};
